import { useInsiderMembershipInformation } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderMembershipInformation";
import { InsiderTermsAndConditionsStatus } from "@faire/web-api--source/indigofair/insider/InsiderTermsAndConditionsStatus";
/**
 * Custom hook to determine the consent status for Insider Terms and Conditions.
 *
 * @example
 * const { isInsiderTermsAndConditionsPendingOrOutdated } = useInsiderTermsAndConditionsConsentStatus();
 * if (isInsiderTermsAndConditionsPendingOrOutdated) {
 *   // Prompt the user to accept the latest Insider terms and conditions.
 * }
 */ export var useInsiderTermsAndConditionsConsentStatus = function() {
    var insiderMembershipInformation = useInsiderMembershipInformation().insiderMembershipInformation;
    var insiderTermsAndConditionsConsentStatus = insiderMembershipInformation === null || insiderMembershipInformation === void 0 ? void 0 : insiderMembershipInformation.terms_acceptance_status;
    var isInsiderTermsAndConditionsPending = insiderTermsAndConditionsConsentStatus === InsiderTermsAndConditionsStatus.PENDING;
    var isInsiderTermsAndConditionsOutdated = insiderTermsAndConditionsConsentStatus === InsiderTermsAndConditionsStatus.OUTDATED;
    var isInsiderTermsAndConditionsPendingOrOutdated = isInsiderTermsAndConditionsPending || isInsiderTermsAndConditionsOutdated;
    var isInsiderTermsAndCondtionsAccepted = insiderTermsAndConditionsConsentStatus === InsiderTermsAndConditionsStatus.ACCEPTED;
    return {
        insiderTermsAndConditionsConsentStatus: insiderTermsAndConditionsConsentStatus,
        isInsiderTermsAndConditionsPending: isInsiderTermsAndConditionsPending,
        isInsiderTermsAndConditionsOutdated: isInsiderTermsAndConditionsOutdated,
        isInsiderTermsAndConditionsPendingOrOutdated: isInsiderTermsAndConditionsPendingOrOutdated,
        isInsiderTermsAndCondtionsAccepted: isInsiderTermsAndCondtionsAccepted
    };
};
